import "react-app-polyfill/ie9";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { ErrorBoundaries } from "@Cyclope-ErrorBoundaries/index";
import { Provider } from "react-redux";
import { StoreTunnelWatch } from "@Cyclope-Store/index";
import TunnelWatchApplicationRouter from "@Cyclope-Router/index";
import { BrowserRouter as Router } from "react-router-dom";
import "@tunnel-stylesheet/styles/style.css";
// import 'moment/locale/fr';
import * as Helpers from "@Cyclope-Utils/index";

/** Configuration dela viriable globale , L'objet window représente une fenêtre contenant un document DOM   */
const API_URL = 'env'; 

/**
 * Initialisation de la traduction
 */
Helpers.initTranslations((window[API_URL].LANGUAGE));

/** Vérification de l'existence de l'element #root-tunnel-watch dans le DOM */
if (document.getElementById("root-tunnel-watch")) {
  /**
   * Combinaison du dom virtual créer par react
   * et le dom réel
   */
  // const Context = React.createContext({audioState : false });
  // MyContext.audioState = false;

  ReactDOM.render(
    <ErrorBoundaries>
      <Provider store={StoreTunnelWatch}>
        <Router>
          <TunnelWatchApplicationRouter />
        </Router>
      </Provider>
    </ErrorBoundaries>,
    document.getElementById("root-tunnel-watch") as HTMLElement
  );
}



// WEBPACK FOOTER //
// ./src/index.tsx